'use client';

import { c } from '../../../utils/tailwind-merge';
import { Separator } from '../../atoms/Separator/Separator';
import { PublisherInfo } from '../../molecules/PublisherInfo/PublisherInfo';
import { PublisherInfoTable } from '../../organisms/PublisherInfoTable/PublisherInfoTable';
import { PublisherOverview } from '../../organisms/PublisherOverview/PublisherOverview';
import { PublisherProfileTabs } from '../../organisms/PublisherProfileTabs/PublisherProfileTabs';
import { SocialMediaTable } from '../../organisms/SocialMediaTable/SocialMediaTable';
import { PublisherProfileTemplateProps } from './PublisherProfileTemplate.types';

export const PublisherProfileTemplate = ({
  tabs,
  overview,
  publisherInfo,
  publisherInfoTable,
  socialMedia,
  microcopy,
  className,
  renderPublisherAssets,
  onOpenCookieSettings,
}: PublisherProfileTemplateProps) => {
  const Desktop = () => (
    <section className="hidden pb-16 lg:block">
      <div className="container w-full space-y-10">
        <div className="grid grid-cols-[minmax(0,_1fr)_396px] items-start gap-6">
          <div className="flex min-w-0 flex-col gap-6 self-start">
            <PublisherOverview
              {...overview}
              onOpenCookieSettings={onOpenCookieSettings}
            />
          </div>
          <aside className="flex flex-col lg:shrink-0">
            <PublisherInfo
              size="big"
              microcopy={microcopy.publisherInfo}
              {...publisherInfo}
            />
            <Separator />
            <PublisherInfoTable
              {...publisherInfoTable}
              microcopy={microcopy.publisherInfoTable}
              rightColumnTextAlign="left"
            />

            <SocialMediaTable
              microcopy={microcopy.socialMedia}
              {...socialMedia}
            />
          </aside>
        </div>
        <PublisherProfileTabs
          defaultValue="assets"
          {...tabs}
          microcopy={microcopy.tabs}
          renderPublisherAssets={renderPublisherAssets}
        />
      </div>
    </section>
  );

  const Mobile = () => (
    <section className={c('grid grid-cols-1 gap-4 px-4 pb-4 lg:hidden')}>
      <PublisherInfo
        size="big"
        microcopy={microcopy.publisherInfo}
        {...publisherInfo}
        className="mt-8"
      />
      <Separator className="my-2" />
      <PublisherInfoTable
        {...publisherInfoTable}
        microcopy={microcopy.publisherInfoTable}
        className="max-w-[710px]"
        rightColumnTextAlign="left"
      />
      <SocialMediaTable
        microcopy={microcopy.socialMedia}
        {...socialMedia}
        className="max-w-[710px]"
      />
      <PublisherOverview
        {...overview}
        onOpenCookieSettings={onOpenCookieSettings}
      />
      <PublisherProfileTabs
        defaultValue="assets"
        {...tabs}
        microcopy={microcopy.tabs}
        renderPublisherAssets={renderPublisherAssets}
      />
    </section>
  );

  return (
    <div className={className}>
      <Desktop />
      <Mobile />
    </div>
  );
};
